<template>
  <div>
    <field-wrapper label="Query" :error="errors.query" v-model="values.query" input-placeholder="Enter search query"
                   description="A full-text search query."/>
  </div>
</template>
<script>
  import fieldWrapper from '@/components/shared/field-wrapper'

  export default {
    components: {fieldWrapper},
    props: {
      values: Object,
      errors: Object
    },
    name: 'queryFilter'
  }
</script>
<style>
</style>
